import {StoreListPage} from 'selectra/pages';

const StoreListWithOutro = props => <StoreListPage {...props} outro />;

export default StoreListWithOutro;
